<div class="tw-relative tw-h-[0] tw-z-10" *ngIf="(permissions$ | async)?.canViewTodayUserDropDown">
  <div class="tw-absolute tw-right-0 tw-top-1 tw-pr-4 lendio-density-2">
    <mat-form-field>
      <mat-select class="no-arrow-transform" [value]="(userId$ | async)" (selectionChange)="onUserIdChanged($event)">
        <mat-option *ngFor="let teamMember of (teamMembers$ | async)"
                    [value]="teamMember.id">
          {{authUserIsFundingDesk ? teamMember.fullName : teamMember.user.first + ' ' + teamMember.user.last}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<mat-tab-group
  mat-stretch-tabs="false"
  (selectedTabChange)="selectedTabChange($event)"
  [selectedIndex]="selectedTabIndex$ | async">

  <mat-tab *ngIf="(permissions$ | async).canViewNewTodayPageTodayTab">
    <ng-template mat-tab-label>
      Today
      <div *ngIf="(todayBadgeCount$ | async) as todayCount" class="tw-ml-2 tw-text-sm counter-pill {{todayCount < 10 ? 'single-digit' : ''}}">
        {{todayCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-action-items-list-view class="tw-border-t" [listId]="'today'">
      </app-user-action-items-list-view>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      Requests
      <div *ngIf="(requestsBadgeCounts$ | async).requestCountTotal as requestsCount" class="tw-ml-2 tw-text-sm counter-pill {{requestsCount < 10 ? 'single-digit' : ''}}">
        {{requestsCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-action-items-list-view class="tw-border-t" [listId]="'requests'">
      </app-user-action-items-list-view>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="(permissions$ | async)?.canViewTodayMessagingTabs">
    <ng-template mat-tab-label>
      Email
      <div *ngIf="(unreadEmailThreadCount$ | async) as emailCount" class="tw-ml-2 tw-text-sm counter-pill {{emailCount < 10 ? 'single-digit' : ''}}">
        {{emailCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-email-list-view class="tw-border-t"></app-user-email-list-view>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="(permissions$ | async)?.canViewTodayMessagingTabs" label="SMS">
    <ng-template mat-tab-label>
      SMS
      <div *ngIf="(unreadSmsThreadCount$ | async) as smsCount" class="tw-ml-2 tw-text-sm counter-pill {{smsCount < 10 ? 'single-digit' : ''}}">
        {{smsCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-sms-list-view class="tw-border-t"></app-user-sms-list-view>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="(permissions$ | async)?.canSeeTodayCallHistoryTab">
    <ng-template mat-tab-label>
      Calls
      <div *ngIf="(missedCallsCount$ | async) as missedCallsCount" class="tw-ml-2 tw-text-sm counter-pill {{missedCallsCount < 10 ? 'single-digit' : ''}}">
        {{missedCallsCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-call-history-list-view class="tw-border-t"></app-user-call-history-list-view>
    </ng-template>
  </mat-tab>

  <mat-tab label="Completed">
    <ng-template matTabContent>
      <app-user-action-items-list-view
        class="tw-border-t"
        [listId]="'requests'"
        [completed]="true"
      >
      </app-user-action-items-list-view>
    </ng-template>
  </mat-tab>


  <mat-tab *ngIf="(permissions$ | async).canViewNewTodayPageTodayTab">
    <ng-template mat-tab-label>
      Follow Up
      <div *ngIf="(followUpBadgeCount$ | async) as followUpCount" class="tw-ml-2 tw-text-sm counter-pill {{followUpCount < 10 ? 'single-digit' : ''}}">
        {{followUpCount}}
      </div>
    </ng-template>
    <ng-template matTabContent>
      <app-user-action-items-list-view class="tw-border-t" [listId]="'followUp'">
      </app-user-action-items-list-view>
    </ng-template>
  </mat-tab>

</mat-tab-group>
